import React, { useEffect, useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Fade,
  Backdrop,
} from '@mui/material';
import kuikPos from '../../services/api/kuikPos';

interface updateTerminalModalProps {
  open: boolean;
  onClose: () => void;
  terminal: any;
}

const UpdateTerminalModal: React.FC<updateTerminalModalProps> = ({
  open,
  onClose,
  terminal,
}) => {
  const [name, setName] = useState('');
  const [serialNumber, setSerialNumber] = useState('');

  const [initialValues, setInitialValues] = useState({
    name: '',
    serialNumber: '',
    ip_address: '',
  });

  useEffect(() => {
    setName(terminal?.name);
    setSerialNumber(terminal?.serial_number);

    setInitialValues({
      name: terminal?.name,
      serialNumber: terminal?.serial_number,
      ip_address: terminal?.ip_address,
    });
  }, [terminal]);

  const handleUpdate = async () => {
    const updatedFields: any = {};
    if (name !== initialValues.name) updatedFields.name = name;
    if (serialNumber !== initialValues.serialNumber)
      updatedFields.serial_number = serialNumber;
    if (Object.keys(updatedFields).length > 0) {
      try {
        await kuikPos.updateTerminal(terminal.id, updatedFields);
        setName('');
        setSerialNumber('');

        onClose();
      } catch (error) {
        console.error('Error updating terminal:', error);
      }
    } else {
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" fontWeight="bold" mb={2}>
            Terminal Düzenleme
          </Typography>

          <TextField
            size="small"
            label="Cihaz Adı"
            variant="outlined"
            fullWidth
            margin="dense"
            value={name}
            onChange={e => setName(e.target.value)}
          />
          <TextField
            size="small"
            label="Seri NO"
            margin="dense"
            variant="outlined"
            fullWidth
            value={serialNumber}
            onChange={e => setSerialNumber(e.target.value)}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <Button variant="contained" color="success" onClick={handleUpdate}>
              DÜZENLE
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default UpdateTerminalModal;
